export default __webpack_public_path__ + "static/media/netzherologo.258bd706.png";